import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { System } from '@app/models';
import { TruncateModule } from '@app/shared/pipes';
import { OrderService, UtilsService } from '@app/shared/services';
import { utils } from '@app/shared/utils';
import { BadgeComponent, ButtonComponent, TooltipDirective } from '@teorema/patron';
import { PopoverModule } from 'primeng/popover';
import { Observable } from 'rxjs';

@Component({
  selector: 'patron-cart-widget',
  templateUrl: './cart-widget.component.html',
  imports: [
    CommonModule,
    ButtonComponent,
    RouterModule,
    PopoverModule,
    TruncateModule,
    TooltipDirective,
    BadgeComponent,
  ],
})
export class CartWidgetComponent {
  showPrices$: Observable<boolean>;
  orderService = inject(OrderService);
  private utilsService = inject(UtilsService);

  constructor() {
    this.showPrices$ = this.utilsService.showPrices();
  }

  get hasOrdersPermission() {
    const systems: any[] = [
      System.MULTIPANEL,
      System.CUSTOMERS,
      System.PRAXIS,
      System.VENDOR,
      System.V3NDOR,
    ];
    const currentSystem = utils.getSystem();
    if (!systems.includes(currentSystem)) return false;
    return utils.checkAccess(['Orders']).result;
  }
}
